import { render, staticRenderFns } from "./CRAddressSelectorExpandable.vue?vue&type=template&id=20229234&scoped=true"
import script from "./CRAddressSelectorExpandable.vue?vue&type=script&lang=js"
export * from "./CRAddressSelectorExpandable.vue?vue&type=script&lang=js"
import style0 from "./CRAddressSelectorExpandable.vue?vue&type=style&index=0&id=20229234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20229234",
  null
  
)

export default component.exports